



























































// eslint-disable-next-line class-methods-use-this
/* eslint-disable @typescript-eslint/camelcase */
// eslint-disable-next-line no-constant-condition
import { Component, Prop, Vue } from 'vue-property-decorator';
import ExportIcon from 'mdi-vue/FileExportOutline';
import api, { apiSandbox } from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import FormInput from '@/components/FormInput.vue';
import AddIcon from 'mdi-vue/Plus';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { ChannelPricingResponse, PriceTier } from '@/libs/api.interfaces';
import BillingFields from '../../../AccountManagement/components/BillingFields.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    AddIcon,
    Checkbox,
    Loader,
    Button,
    ExportIcon,
    SearchField,
    SearchRow,
    Select,
    Modal,
    FormInput,
    BillingFields,

  },
})

export default class PaymentChannel extends Vue {
  @Prop(String) channelId!: string;
  @Prop(String) merchantCode!: string;
  @Prop(String) credential!: string;
  @Prop(String) title!: string;
  @Prop(String) phase!: string;
  billingTypes = [
    { label: 'Normal', value: 'normal' },
    { label: 'MDR', value: 'mdr' },
    { label: 'Tiering per Traffic', value: 'tiring' },
    { label: 'Tiering per Amount', value: 'tiring_amount' },
    { label: 'Mixed', value: 'mixed' },
  ];

  BussinessModels = [
    { label: 'Direct Bundling', value: '0' },
    { label: 'Direct Non Bundling', value: '1' },
    { label: 'Escrow', value: '2' },
  ];

  billing: BillingFieldsModel = {
    bussinessType: '',
    transactionFeeType: { label: 'Normal', value: 'normal' },
    transactionFeeValue: '',
    feeBank: '',
    includePPN: false,
    bussinessModel: { label: 'Direct Bundling', value: '0' },
    description: '',
    live: false,
  }

  serviceName = '';
  merchant_code = '';
  credentials = '';

  creditCardBill = [
    'auth', 'sale', 'void', 'refund', 'auth_declined', 'sale_declined', 'auth_filtered', 'sale_filtered',
  ]

  close() {
    this.$emit('modal', false);
  }

  mounted() {
    this.getPricing();
  }

  async getPricing() {
    try {
      // eslint-disable-next-line max-len
      const { data } = await apiSandbox.get<ChannelPricingResponse>(`consumer/channel/edit?credentials=${this.credential}&channel_id=${this.channelId}&merchant_code=${this.merchantCode}`);
      let type = data.billType || 'normal';
      if (data.multiple_billType.length > 1) {
        type = 'mixed';
      }

      let feeValue: string | Tier[] | MixedPricing;
      if (type === 'mixed') {
        feeValue = {
          normal: '0',
          mdr: '0',
        } as MixedPricing;
        data.multiple_billType.forEach((e) => {
          if (e.type === 'normal') {
            (feeValue as MixedPricing).normal = e.price;
          } else {
            (feeValue as MixedPricing).mdr = e.price;
          }
        });
      } else if (type === 'normal' || type === 'mdr') {
        feeValue = data.price as string;
      } else {
        feeValue = (data.price as PriceTier[]).map((e) => ({
          min: e.traffic_min.toString() || '0',
          max: e.traffic.toString() || '0',
          price: e.price.toString() || '0',
          type: e.type || '',
        }));
      }

      this.serviceName = data.service;
      this.merchantCode = data.merchant_code;
      this.credentials = data.credentials;
      this.billing = {
        bussinessType: data.business_type,
        transactionFeeType: this.billingTypes.find((e) => e.value === type) || { label: 'Normal', value: 'normal' },
        feeBank: data.fee_bank ? data.fee_bank.toString() : '0',
        includePPN: data.ppn === 1,
        // eslint-disable-next-line max-len
        bussinessModel: this.BussinessModels.find((e) => e.value === data.business_model.toString()) || { label: 'Direct Bundling', value: '0' },
        description: data.descp,
        transactionFeeValue: feeValue,
        statusBill: data.service === 'credit_card_pcs'
          ? data.transaction_type.reduce((prev, cur) => {
            const current = prev;
            const curIndex = this.creditCardBill.findIndex((e) => e === cur);
            current[curIndex] = true;
            return current;
          }, [false, false, false, false, false, false, false, false] as boolean[])
          : undefined,
        live: data.status !== '0',
      };
    } catch (error) {
      console.log(error);
    }
  }

  async updatePricing() {
    try {
      let feeValue;
      if (this.billing.transactionFeeType.value === 'tiring'
        || this.billing.transactionFeeType.value === 'tiring_amount') {
        feeValue = (this.billing.transactionFeeValue as Tier[]).map((e) => ({
          traffic_min: e.min,
          traffic: e.max,
          price: e.price,
          type: e.type,
        }));
      } else if (this.billing.transactionFeeType.value === 'mixed') {
        const mixedPrice = this.billing.transactionFeeValue as MixedPricing;
        feeValue = mixedPrice.normal;
      } else {
        feeValue = this.billing.transactionFeeValue;
      }

      let billingData;
      if (this.billing.transactionFeeType.value === 'mixed') {
        const mixedPrice = this.billing.transactionFeeValue as MixedPricing;
        billingData = JSON.stringify([
          { type: 'normal', price: mixedPrice.normal },
          { type: 'mdr', price: mixedPrice.mdr },
        ]);
      } else {
        billingData = JSON.stringify([
          { type: this.billing.transactionFeeType.value, price: this.billing.transactionFeeValue },
        ]);
      }

      await apiSandbox.post('consumer/channel/edit', {
        merchant_code: this.merchantCode,
        service_name: this.serviceName,
        credential: this.credentials,
        bill_type: this.billing.transactionFeeType.value === 'mixed' ? 'normal' : this.billing.transactionFeeType.value,
        price: feeValue,
        fee_bank: this.billing.feeBank,
        ppn: this.billing.includePPN ? '1' : '0',
        descp: this.billing.description,
        business_type: this.billing.bussinessType,
        billing_data: billingData,
        business_model: this.billing.bussinessModel.value,
        transaction_type: JSON.stringify(this.billing.statusBill
          ? this.billing.statusBill.reduce((prev, cur, index) => {
            if (cur) prev.push(this.creditCardBill[index]);
            return prev;
          }, [] as string[])
          : []),
      });
      showToast(ToastType.SUCCESS, 'Success Update Pricing', 'Congrats, your changes have been saved');
      const params = this.$route.query;

      let page = 1;
      if (typeof params.page === 'string') {
        page = Number(params.page);
      }
      this.$emit('getDisbursment', { status: '' }, false, page);

      this.close();
    } catch (error) {
      showToast(ToastType.FAILED, 'Oops… Sorry', error.response.data);
    }
  }
}
